import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccessLog } from '@app/_models/access-log.model';
import { AccessManagementService } from '@app/_services/access-management.service';
import { faSearch, faEye } from '@fortawesome/free-solid-svg-icons';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-access-log',
    templateUrl: './access-log.component.html',
    styleUrls: ['./access-log.component.css'],
    standalone: false
})
export class AccessLogComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private accessManagmentService: AccessManagementService) { }

  propertyId = signal<number | null>(null);

  pagesize = 100;

  searchUser = signal('');

  p: number = 1;

  faSearch = faSearch;
  faEye = faEye;

  accesslog = signal<AccessLog[]>([]);
  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.route.paramMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (params) => {
          const propertyId = Number(params.get('propertyid'));
          if (Number.isNaN(propertyId)) {
            this.accesslog.set([]);
            return;
          }

          this.propertyId.set(propertyId);
          this.loadAccessLogs(propertyId);
        }
      });
  }

  private loadAccessLogs(propertyId: number): void {
    this.accessManagmentService.getProperyAccessLogs(propertyId, this.pagesize)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.accesslog.set(data);
        },
        error: () => {
          this.accesslog.set([]);
        }
      });
  }

}
